import { intelClient } from 'src/api/config';

function fetchInsights(params) {
  return intelClient.get('/api/insights/downloads', { params });
}

export default fetchInsights;
